import { render, staticRenderFns } from "./ArenaVehicleTypeList.vue?vue&type=template&id=79efd2fd"
import script from "./ArenaVehicleTypeList.vue?vue&type=script&lang=js"
export * from "./ArenaVehicleTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports